const PricesData = {
  answering: [
    {
      type: 'ANSWERING_BASIC',
      title: 'Answering Basic',
      features: [
        'Unique Telephone Number',
        'Immediate Message Notifications',
        'Easy Setup',
        '$1.50 per additional call',
        'Customized Call Handling',
        'Music on Hold',
        'Scalable Plans',
      ],
      price: 50,
      duration: 'per month',
    },
    {
      type: 'ANSWERING_SILVER',
      title: 'Answering Silver',
      features: [
        'Unique Telephone Number',
        'Email and SMS Alerts',
        'Virtual Phone App',
        'Customized Music on Hold',
        'Customized Call Handling',
        '24/7 Live Coverage',
        'Free Call Patching / Transfers*',
        'Appointment Setting',
      ],
      price: 100,
      duration: 'per month',
    },
    {
      type: 'ANSWERING_PREMIUM',
      title: 'Answering Premium',
      features: [
        'Unique Telephone Number',
        'Email and SMS Alerts',
        'Virtual Phone App',
        'Customized Music on Hold',
        'Customized Call Handling',
        '24/7 Live Coverage',
        'Free Call Patching / Transfers*',
        'Appointment Setting',
      ],
      price: 250,
      duration: 'per month',
    },
  ],
  dedicated: [
    {
      type: 'DEDICATED_VIRT',
      title: 'Dedicated Virtual Assistant',
      features: [
        'Dedicated Virtual Assistant',
        '40-160 hrs per agent / month',
        'Available Mon-Sat: 8:30am – 5pm',
        'Email, Phone, Chat, SMS Support',
        '24/7 Live Coverage',
      ],
      price: 280,
      duration: '40 hours',
    },
    {
      type: 'DEDICATED_PROF',
      title: 'Dedicated IT Technical Support',
      features: [
        'Dedicated Virtual Assistant',
        '40-160 hrs per agent / month',
        'Available Mon-Sat: 8:30am – 5pm',
        'Email, Phone, Chat, SMS Support',
        '24/7 Live Coverage',
      ],
      price: 340,
      duration: '40 hours',
    },
  ],
  cayman: [
    {
      type: 'CAYMAN1',
      title: 'Pay & Go Answering Service',
      features: [
        'Dedicated 345 Phone Numbers',
        'Customized Call Handling',
        'Mon-Fri 8:30-5:00pm',
        'Email, Phone, Chat, SMS Support',
        'General FAQ Provided',
        'Hoax Calls Free',
      ],
      price: 150,
      duration: 'per month',
    },
    {
      type: 'CAYMAN2',
      title: '250 Minutes Package',
      features: [
        'Dedicated 345 Phone Numbers',
        'Customized Call Handling',
        'Mon-Fri 8:30-5:00pm',
        'Email, Phone, Chat, SMS Support',
        'General FAQ Provided',
        'Hoax Calls Free',
        '120 Cal Patch / Transfer Minutes',
      ],
      price: 250,
      duration: 'per month',
    },
    {
      type: 'CAYMAN3',
      title: '500 Minutes Package',
      features: [
        'Dedicated 345 Phone Numbers',
        'Customized Call Handling',
        'Mon-Fri 8:30-5:00pm',
        'Email, Phone, Chat, SMS Support',
        'General FAQ Provided',
        'Hoax Calls Free',
        '200 Cal Patch / Transfer Minutes',
      ],
      price: 300,
      duration: 'per month',
    },
  ],
  callCenterService:[
    {
      type: 'CALLCENTERSERVICE',
      title: 'Call Center Services',
      features: [
        'Inbound Sales',
        'Lead Generation and Qualification',
        'Reservations and Appointment Setting',
        'Outbound',
      ],
      price: 90,
      duration: 'per month',
    },
  ],
  jamaica:[
    {
      type: 'ANSWERING_BASIC',
      title: 'Answering Basic Include 50 Calls Per month',
      features: [
        "Easy Setup",
        "Unique Telephone Number",
        "Customized Call Handling",
        "Immediate Message Notification",
        "Music On Hold",
        "$1.50 per additional call"
      ],
      price: 50.00,
      duration: 'per month',
    },
    {
      type: 'ANSWERING_SILVER',
      title: 'Answering Silver Include 110 Calls Per month',
      features: [
        "Easy Setup",
        "Unique Telephone Number",
        "Customized Call Handling",
        "Immediate Message Notification",
        "Customized Music On Hold",
        "Free call patching/ Transfer*",
        "Appointment Setting",
        "Virtual Mobile App",
        "$1.00 per additional call"
      ],
      price: 100.00,
      duration: 'per month',
    },
    {
      type: 'CORPORATE_BUSINESS',
      title: 'Corporate Business Address',
      features: [
        "Use your new address instantly",
        "Prestigious Kingston address",
        "Mail collection & notification",
        "Mail pick-up & drop-off location",
        "Mail scan to email"
      ],
      price: 55,
      duration: 'per month',
    },
  ]
}

export default PricesData
